import { FormEnrollment } from "models/enrollments/FormEnrollment";
import { Node as Stage, NodePosition } from "models/nodes/Node";
import { useState } from "react";

interface NodeProps {
    node: Stage
    readonly: boolean;
    onDelete: (id: string) => void;
    onUpdate: (updatedNode: Stage) => void;
}

const NodeComponent: React.FC<NodeProps> = ({ node, readonly, onDelete, onUpdate }) => {

    const [index, setIndex] = useState<number>(node.index);

    const handleIndexChange = (newIndex: number) => {
        setIndex(() => newIndex);

        node.index = newIndex;
        onUpdate(node);
    }

    const isFormEnrollment = (enrollment: any): enrollment is FormEnrollment => {
        return enrollment && "form" in enrollment && enrollment.form?.name;
      };

      return (
        <div className="p-4 border border-gray-200 rounded-lg bg-white shadow-sm space-y-3">
          {isFormEnrollment(node.enrollment) && (
            <h4 className="text-md font-semibold text-gray-700">
              Form: {node.enrollment.form.name}
            </h4>
          )}
      
          <h4 className="text-md font-semibold">Stage {index}</h4>
      
          {!readonly && (
            <div>
              <label className="text-sm text-gray-700">
                <strong>Stage: </strong>
                <input
                  disabled={readonly}
                  type="number"
                  value={index}
                  onChange={(e) => handleIndexChange(Number(e.target.value))}
                  className="mt-1 ml-2 px-2 py-1 w-12 border border-gray-300 rounded text-center"
                />
              </label>
            </div>
          )}
      
          {!readonly && (
            <button
              onClick={() => onDelete(node.id)}
              className="px-3 py-1 bg-red-500 text-white text-sm rounded hover:bg-red-600 transition-colors"
            >
              Delete
            </button>
          )}
        </div>
      );
    }
      

export default NodeComponent;